const ordercategory = {
    getlist: 'ordercategory/getlist',
    add: 'ordercategory/add',
    update: 'ordercategory/update',
    remove: 'ordercategory/remove',
    get: 'ordercategory/get',
    getall: 'ordercategory/getall',
    clearcache: 'ordercategory/clear-cache',
}
export default ordercategory
